import { render, staticRenderFns } from "./ScalesCreateOrEditPage.vue?vue&type=template&id=5e2499c4&scoped=true&"
import script from "./ScalesCreateOrEditPage.vue?vue&type=script&lang=js&"
export * from "./ScalesCreateOrEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2499c4",
  null
  
)

export default component.exports